import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { IntelligenceComponent } from './intelligence.component';

export const IntelligenceStates : Array<NgHybridStateDeclaration> = [
  {
    component: IntelligenceComponent,
    name     : 'app.intelligence',
    url      : '/intelligence'
  }
];
